<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-btn
      fab
      dark
      top
      right
      fixed
      small
      @click="close"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-row
      align="center"
      justify="center"
    >
      <v-col cols="12" md="12" class="text-center">
        <img v-if="image" :src="image" class="preview-image">
        <TextRecogniser
          v-if="showTextRecogniser"
          :quote-image="quoteImage"
          @preview="previewImage"
          @hastext="recognisedText"
          @statechanged="recogniserState"
        />

        <v-btn v-if="canCreateQuote" @click="writeQuote" class="mt-10">
          <v-icon>comment-edit</v-icon>
          <span>Type a quote</span>
        </v-btn>

        <EditQuote
          v-if="canEditQuote"
          :quote-text="quoteText"
          @submit="quoteAdded"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EditQuote from '../components/EditQuote.vue'
import TextRecogniser from '../components/TextRecogniser.vue'

export default {
  name: 'AddQuote',
  components: {
    EditQuote,
    TextRecogniser
  },
  data () {
    return {
      quoteText: null,
      image: null,
      mode: null,
      quoteImage: this.$store.state.imageFile
    }
  },
  computed: {
    canEditQuote () {
      return this.image || this.quoteText !== null
    },
    canCreateQuote () {
      return this.mode === null && !(this.image || this.quoteImage) && this.quoteText === null
    },
    showTextRecogniser () {
      return this.image || this.quoteImage || this.quoteText === null
    }
  },
  methods: {
    previewImage (image) {
      this.image = window.URL.createObjectURL(image)
    },
    recognisedText (text) {
      this.quoteText = text
    },
    close () {
      this.$store.commit('setFile', null)
      this.$router.go(-1)
    },
    quoteAdded (saveQuote) {
      saveQuote.then((quote) => {
        this.$store.commit('setFile', null)
        this.$router.replace({ name: 'quote', params: { id: quote.id } })
      })
    },
    writeQuote () {
      this.quoteText = ' '
    },
    recogniserState () {
      this.mode = 'image'
    }
  }
}
</script>

<style>
.preview-image {
  max-width: 100%
}
</style>
